import React from 'react'

const SettingsIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="settingsGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(160, 160, 180, 1)" />
          <stop offset="100%" stopColor="rgba(120, 120, 140, 1)" />
        </linearGradient>
        <filter id="settingsGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Gear teeth */}
      <path 
        d="M12 2l1.5 3.5L17 7l-1.5 3.5L17 14l-3.5 1.5L12 19l-1.5-3.5L7 14l1.5-3.5L7 7l3.5-1.5L12 2z"
        stroke="url(#settingsGradient)"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
        filter="url(#settingsGlow)"
      />
      
      {/* Center circle */}
      <circle 
        cx="12" 
        cy="10.5" 
        r="3"
        fill="url(#settingsGradient)"
        filter="url(#settingsGlow)"
      />
      
      {/* Inner highlight */}
      <circle 
        cx="12" 
        cy="10.5" 
        r="1.5"
        fill="rgba(255, 255, 255, 0.5)"
      />
    </svg>
  )
}

export default SettingsIcon
